<div class="p-6">
  <div class="flex items-center gap-3">
    <button type="button" class="text-metro-blue-secondary hover:opacity-70" (click)="goBack()">‹ {{ '::Back' | abpLocalization }}</button>
  </div>

  <h3 class="font-bold mt-2">
    {{ '::ReassignClientSommelierTitle' | abpLocalization: (info?.clientName || '') }}
  </h3>

  @if (isLoading) {
    <p class="text-sm text-gray-400 mt-4">{{ '::Loading' | abpLocalization }}...</p>
  } @else if (!info || !info.isClient) {
    <p class="text-sm text-gray-500 mt-4">{{ '::Reassign:UserIsNotClient' | abpLocalization }}</p>
    <!-- winepassport#387 — se quitó "Convertir en cliente" (venía de #348 / WP-002). -->
  } @else {
    <div class="mt-4 md:max-w-3xl border border-gray-200 rounded-xl p-4 flex flex-col sm:flex-row sm:items-center gap-4">
      <div class="flex items-center gap-3 min-w-0 flex-1">
        @if (currentPhotoUrl) {
          <img [src]="currentPhotoUrl" alt="" class="w-12 h-12 rounded-full object-cover shrink-0" />
        } @else {
          <div class="w-12 h-12 rounded-full bg-slate-100 text-metro-blue-secondary font-semibold
                      flex items-center justify-center shrink-0">
            {{ initials(info.currentSommelierName) }}
          </div>
        }
        <div class="min-w-0">
          <div class="font-semibold text-metrodev-blue truncate">
            {{ info.currentSommelierName || ('::MySommelier:None' | abpLocalization) }}
          </div>
          <div class="text-sm text-gray-500 truncate">
            {{ info.currentSommelierCity || '-' }}<span *ngIf="info.currentSommelierRegion">, {{ info.currentSommelierRegion }}</span>
          </div>
        </div>
      </div>
      <div class="w-full sm:w-auto">
        <app-metro-button
          variant="secondary"
          [fullWidth]="true"
          text="{{ '::MySommelier:Change' | abpLocalization }}"
          (clicked)="openModal()">
        </app-metro-button>
      </div>
    </div>
    <!-- winepassport#348 (WP-002) — convertir la cuenta de cliente a sommelier (requiere ficha de sommelier existente) -->
    <div class="mt-3 w-full sm:w-auto">
      <app-metro-button
        variant="secondary"
        text="Convertir en sommelier"
        [disabled]="isSwitchingRole"
        (clicked)="changeRole('sommelier')">
      </app-metro-button>
    </div>
  }
</div>

<app-metro-modal
  [isOpen]="showModal"
  [title]="'::MySommelier:ChooseTitle' | abpLocalization"
  [confirmText]="'::MySommelier:ConfirmAssignment' | abpLocalization"
  [closeOnConfirm]="false"
  (close)="closeModal()"
  (cancelAction)="closeModal()"
  (confirm)="confirm()">
  <div class="font-sans space-y-3">
    <app-metro-search-input
      [placeholder]="'::NameOrSurname' | abpLocalization"
      (search)="onSearch($event)"
      (cleared)="onClearSearch()">
    </app-metro-search-input>

    <div class="flex flex-col md:flex-row gap-2">
      <div class="flex-1">
        <app-metro-form-select
          [placeholder]="'::Province' | abpLocalization"
          [options]="provinceOptions"
          [(ngModel)]="province"
          (selectionChange)="onFilter()"
          [allowSearch]="true">
        </app-metro-form-select>
      </div>
      <div class="flex-1">
        <app-metro-form-select
          [placeholder]="'::City' | abpLocalization"
          [options]="localityOptions"
          [(ngModel)]="locality"
          (selectionChange)="onFilter()"
          [allowSearch]="true">
        </app-metro-form-select>
      </div>
    </div>

    <div class="border border-gray-200 rounded-lg divide-y divide-gray-100 max-h-72 overflow-y-auto">
      @if (isSearching) {
        <div class="p-3 text-sm text-gray-400">{{ '::Loading' | abpLocalization }}...</div>
      } @else if (searchError) {
        <div class="p-3 text-sm text-red-500">{{ '::MySommelier:SearchError' | abpLocalization }}</div>
      } @else if (results.length === 0) {
        <div class="p-3 text-sm text-gray-500">{{ '::MySommelier:NoResults' | abpLocalization }}</div>
      } @else {
        @for (s of results; track s.id) {
          <button
            type="button"
            class="w-full text-left p-3 flex items-center gap-3 hover:bg-gray-50"
            [class.bg-gray-100]="selected?.id === s.id"
            (click)="pick(s)">
            @if (resultPhotos[s.id]) {
              <img [src]="resultPhotos[s.id]" alt="" class="w-10 h-10 rounded-full object-cover shrink-0" />
            } @else {
              <div class="w-10 h-10 rounded-full bg-slate-100 text-metro-blue-secondary text-xs font-semibold
                          flex items-center justify-center shrink-0">
                {{ initials(s.name + ' ' + s.surname) }}
              </div>
            }
            <span class="min-w-0 flex-1">
              <span class="font-medium text-metrodev-blue block truncate">{{ s.name }} {{ s.surname }}</span>
              <span class="text-sm text-gray-500 block truncate">
                {{ s.city || '-' }}<span *ngIf="s.region">, {{ s.region }}</span>
              </span>
            </span>
            @if (selected?.id === s.id) {
              <span class="text-xs font-semibold text-metrodev-blue shrink-0">✓</span>
            }
          </button>
        }
      }
    </div>
  </div>
</app-metro-modal>
